module.exports = __webpack_public_path__ + "img/doc.5b131e2d.png";